import { createContext, useState, useMemo } from "react";

export const GeoContext = createContext();

const defaultLocation = 'absecon';
const secondaryLocation = 'martin';

export function GeoContextProvider({ children }) {
  const [location, setLocation] = useState(defaultLocation);
  const [consequenceType, setConsequenceType] = useState("damages");
  const [defaultPosition, setDefaultPosition] = useState(false);

  const [tilesetStyle, setTilesetStyle] = useState(undefined);
  const [roadTilesetStyle, setRoadTilesetStyle] = useState(undefined);

  const [buildingsVisible, setBuildingsVisible] = useState(true);
  const [roadsVisible, setRoadsVisible] = useState(false);
  const [roadsDisabled, setRoadsDisabled] = useState(true);

  const [structureCounts, setStructureCounts] = useState(undefined)

  const geoContextValue = useMemo(() => ({
    getLocation: location,
    updateLocation: setLocation,
    toggleLocation: () => {
      setLocation((prevLoc) => (prevLoc === defaultLocation ? secondaryLocation : defaultLocation));
    },

    getConsequenceType: consequenceType,
    updateConsequenceType: setConsequenceType,

    getDefaultPosition: defaultPosition,
    updateDefaultPosition: setDefaultPosition,

    getTilesetStyle: tilesetStyle,
    updateTilesetStyle: setTilesetStyle,

    getRoadTilesetStyle: roadTilesetStyle,
    updateRoadTilesetStyle: setRoadTilesetStyle,

    getBuildingsVisible: buildingsVisible,
    updateBuildingsVisible: setBuildingsVisible,

    getRoadsVisible: roadsVisible,
    updateRoadsVisible: setRoadsVisible,

    getRoadsDisabled: roadsDisabled,
    updateRoadsDisabled: setRoadsDisabled,

    getStructureCounts: structureCounts,
    updateStructureCounts: setStructureCounts
  }), [
    location, consequenceType, defaultPosition, tilesetStyle,
    roadTilesetStyle, buildingsVisible, roadsVisible, structureCounts
  ]);

  return (
    <GeoContext.Provider value={geoContextValue}>
      {children}
    </GeoContext.Provider>
  );
}
